<script>
import CheckboxGroup from "../../../Shared/CheckboxGroup.vue";
import ModalDialog from "../../../Shared/ModalDialog.vue";
import FieldInput from "../../../Shared/FieldInput.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
import TableWrapper from "../../../Shared/Table/TableWrapper.vue";
import TableRow from "../../../Shared/Table/TableRow.vue";
import TableCell from "../../../Shared/Table/TableCell.vue";
import Icon from "../../../Shared/Icon.vue";

export default {
    name: "AddAttendeeModal" ,
    components: {Icon, TableCell, TableRow, TableWrapper, SelectInput, FieldInput, ModalDialog, CheckboxGroup},
    props: {
        attendees: Array,
        fieldGroups: Array,
        messageId: Number,
    },
    data() {
        return {
            form: this.$inertia.form({
                attendeesToAdd: 'all',
                selectedAttendees: [],
                searchCriteria: [
                    {tableField: null, value: null}
                ],
            }),
        }
    },
    methods: {
        show() {
            this.$refs.modal.show()
        },
        hide() {
            this.form.reset()
            this.$refs.modal.hide()
        },
        addSearchCriteria(idx=0) {
            this.form.searchCriteria.splice(idx+1, 0, {tableField: null, value: null})
        },
        removeSearchCriteria(idx) {
            this.form.searchCriteria.splice(idx, 1)
        },
        submit() {
            this.form.post(this.route('messages.recipients.store', [this.messageId]))
            this.hide()
        },
    }
}
</script>

<template>
    <modal-dialog
        title="Add Attendees to Message"
        @submit="submit"
        @cancel="hide"
        ref="modal"
    >
        <select-input
            v-model="form.attendeesToAdd"
            label="Attendees to add"
            class="py-4"
        >
            <option value="all">All attendees</option>
            <option value="select">Select attendees</option>
            <option value="criteria">Attendees that match specified criteria</option>
        </select-input>

        <div v-if="form.attendeesToAdd === 'select'">
            <checkbox-group v-model="form.selectedAttendees" :entries="attendees" :inline="true"></checkbox-group>
        </div>

        <table-wrapper v-if="form.attendeesToAdd === 'criteria'" :headers="['Field', 'Value']" :text-wrap="false">
            <table-row v-for="(criteria, idx) in form.searchCriteria" :key="idx">
                <table-cell>
                    <select-input v-model="criteria.tableField" @change="criteria.value = null">
                        <option :value="null" disabled selected hidden>Select a field...</option>
                        <optgroup v-for="group in fieldGroups" :label="group.label" :key="group.label">
                            <option v-for="field in group.fields" :key="field" v-text="field"></option>
                        </optgroup>
                    </select-input>
                </table-cell>
                <table-cell>
                    <field-input class="w-full" v-model="criteria.value" :table-field="criteria.tableField"></field-input>
                </table-cell>
                <table-cell>
                    <button type="button" @click="addSearchCriteria(idx)"
                            title="Add new search criteria"
                            class="px-1 py-1 ml-auto rounded bg-indigo-600 text-white text-sm leading-4 font-semibold whitespace-nowrap hover:bg-indigo-800 focus:bg-indigo-800"
                            tabindex="-1">
                        <icon name="add-solid" class="w-3 h-3 fill-white"/>
                    </button>
                    <button v-show="form.searchCriteria.length > 1"
                            type="button" @click="removeSearchCriteria(idx)"
                            title="Remove search criteria"
                            class="px-1 py-1 ml-1 rounded bg-red-600 text-white text-sm leading-4 font-semibold whitespace-nowrap hover:bg-red-800 focus:bg-red-800"
                            tabindex="-1">
                        <icon name="close" class="w-3 h-3 fill-white"/>
                    </button>
                </table-cell>
            </table-row>

        </table-wrapper>

    </modal-dialog>
</template>

<style scoped>

</style>
